import curriedNamespaceAction from "../../../../reducers/helpers";

const REDUCER_TDP_TITLE_AND_ESCROW = "tdpTitleAndEscrowReducer";
const wrap = curriedNamespaceAction(REDUCER_TDP_TITLE_AND_ESCROW);

export const sentBlueprintRequest = () =>
  wrap({
    type: "SENT_BLUEPRINT_REQ_SUCCESS",
  });

export const fetchSendBlueprintRequestFailure = (error) =>
  wrap({
    type: "SEND_BLUEPRINT_REQ_FAILURE",
    error,
  });

export const showSuccessToast = (data) =>
  wrap({
    type: "SHOW_SUCCESS_TOAST",
    data,
  });

export const fetchgetTitleAndEscrowFailure = (error) =>
  wrap({
    type: "FETCH_GET_TITLE_AND_ESCROW_FAILURE",
    error,
  });

export const fetchDismissCardFailure = (error) =>
  wrap({
    type: "DISMISS_FAILURE",
    error,
  });

export const saveTitleAndEscrow = (data) =>
  wrap({
    type: "SAVE_TITLE_AND_ESCROW",
    data,
  });

export const saveListingStage = (data) => wrap({ type: "SAVE_LISTING_STAGE", data });

export const getTitleAndEscrowStart = () => wrap({ type: "GET_TITLE_AND_ESCROW_START" });

export const getListingStageStart = () => wrap({ type: "GET_LISTING_STAGE_START" });

export const SubmitReqState = (data) => wrap({ type: "IS_SUBMITTING_REQ", data });
